/**
 * Returns a random integer between min (inclusive) and max (exclusive)
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(minInclusive: number, maxExclusive: number) {
  return Math.floor(Math.random() * (maxExclusive - minInclusive)) + minInclusive;
}

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const CHARS_LEN = CHARS.length;

export function getRandomString(size: number) {
  const str: string[] = [];
  for (let i = 0; i < size; i++) {
    str.push(CHARS[getRandomInt(0, CHARS_LEN)]);
  }
  return str.join('');
}
